// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Outer Layout Container
   ========================================================================== */
.theme-outer-par {
  width: 100%;
  margin-top: 54px;
  background-color: #f8fafc;
  color: #0f172a;
  transition: background-color 0.3s ease, color 0.3s ease;
  min-height: calc(100vh - 70px);
  padding-bottom: 6rem;
  box-sizing: border-box;
  font-family: 'Inter', 'Outfit', sans-serif;
}

.dark .theme-outer-par {
  background-color: #0f172a;
  color: #f8fafc;
}

/* ==========================================================================
   Sticky Header
   ========================================================================== */
.theme-sticky-header {
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid rgba(226, 232, 240, 0.7);
  background-color: rgba(248, 250, 252, 0.9);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.dark .theme-sticky-header {
  border-bottom: 1px solid rgba(51, 65, 85, 0.7);
  background-color: rgba(15, 23, 42, 0.9);
}

.theme-header-content {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  height: 4rem;
  max-width: 48rem;
  align-items: center;
  justify-content: space-between;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  box-sizing: border-box;
}

.theme-header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* ==========================================================================
   Back Button & Title
   ========================================================================== */
.theme-back-button {
  display: flex;
  height: 2.5rem;
  width: 2.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border: none;
  background-color: #f1f5f9;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.dark .theme-back-button {
  background-color: #1e293b;
}

.theme-back-button:hover {
  background-color: #e2e8f0;
}

.dark .theme-back-button:hover {
  background-color: #334155;
}

.theme-back-button svg {
  height: 1.25rem;
  width: 1.25rem;
  color: #64748b;
  transition: color 0.3s ease;
  stroke: currentColor;
}

.dark .theme-back-button svg {
  color: #94a3b8;
}

.theme-header-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.dark .theme-header-title {
  color: #f8fafc;
}

/* ==========================================================================
   Main Content Layout
   ========================================================================== */
.theme-main-content {
  margin-left: auto;
  margin-right: auto;
  max-width: 48rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 2rem;
  padding-bottom: 2rem;
  box-sizing: border-box;
  width: 100%;
}

/* ==========================================================================
   Settings Card Container
   ========================================================================== */
.theme-settings-card {
  border-radius: 28px;
  border: 1px solid rgba(226, 232, 240, 0.7);
  background-color: #ffffff;
  padding: 1.5rem;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
  transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
  box-sizing: border-box;
}

.dark .theme-settings-card {
  border: 1px solid rgba(51, 65, 85, 0.7);
  background-color: #0f172a;
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.4);
}

/* ==========================================================================
   Appearance Header Info
   ========================================================================== */
.theme-appearance-section {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 1rem;
}

.theme-card-heading {
  font-size: 1.125rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.dark .theme-card-heading {
  color: #f8fafc;
}

.theme-card-subheading {
  margin-top: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5rem;
  color: #64748b;
  margin-bottom: 0;
}

.dark .theme-card-subheading {
  color: #94a3b8;
}

/* ==========================================================================
   Active Theme Badge
   ========================================================================== */
.theme-active-badge {
  border-radius: 9999px;
  background-color: #E6F2FF;
  padding: 0.5rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #007BFF;
  line-height: 1.2;
}

.theme-active-badge .active-badge-label {
  font-size: 0.7rem;
  font-weight: 500;
}

.theme-active-badge .active-badge-value {
  font-size: 0.85rem;
  font-weight: 700;
}

.dark .theme-active-badge {
  background-color: rgba(59, 130, 246, 0.15);
  color: #3b82f6;
}

/* ==========================================================================
   Cards Grid
   ========================================================================== */
.theme-cards-grid {
  margin-top: 1.5rem;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

@media (min-width: 768px) {
  .theme-cards-grid {
    grid-template-columns: 1fr 1fr;
  }
}

/* ==========================================================================
   Theme Selection Card Buttons
   ========================================================================== */
.theme-card {
  border-radius: 24px;
  border: 1px solid rgba(226, 232, 240, 0.7);
  padding: 1.25rem;
  text-align: left;
  transition: all 0.2s ease;
  background-color: #ffffff;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
}

.dark .theme-card {
  border: 1px solid rgba(51, 65, 85, 0.7);
  background-color: #0f172a;
}

.theme-card:hover {
  border-color: rgba(37, 99, 235, 0.4);
  background-color: #f8fafc;
}

.dark .theme-card:hover {
  border-color: rgba(59, 130, 246, 0.4);
  background-color: rgba(30, 41, 59, 0.4);
}

.theme-card-disabled {
  cursor: not-allowed !important;
}

.theme-card-disabled .theme-card-title {
  color: #64748b;
}

.theme-card-disabled .theme-card-description {
  color: #94a3b8;
}

.theme-card-disabled:hover {
  border-color: rgba(226, 232, 240, 0.7) !important;
  background-color: #ffffff !important;
  box-shadow: none !important;
}

.dark .theme-card-disabled:hover {
  border-color: rgba(51, 65, 85, 0.7) !important;
  background-color: #0f172a !important;
  box-shadow: none !important;
}

.theme-card-active {
  border-color: #3b82f6 !important;
  background-color: #ffffff !important;
  box-shadow: none !important;
}

.dark .theme-card-active {
  border-color: #3b82f6 !important;
  background-color: #0f172a !important;
  box-shadow: none !important;
}

.theme-card-header {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 1rem;
}

/* ==========================================================================
   Theme Card Icons
   ========================================================================== */
.theme-card-icon-wrapper.light-icon {
  display: flex;
  height: 3rem;
  width: 3rem;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  background-color: #fef3c7;
  color: #d97706;
  border: 1px solid #fde68a;
}

.theme-card-icon-wrapper.light-icon svg {
  height: 1.25rem;
  width: 1.25rem;
}

.theme-card-icon-wrapper.dark-icon {
  display: flex;
  height: 3rem;
  width: 3rem;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  background-color: #0f172a;
  color: #ffffff;
  border: 1px solid #1e293b;
}

.theme-card-icon-wrapper.dark-icon svg {
  height: 1.25rem;
  width: 1.25rem;
}

/* ==========================================================================
   Checkmark Wrapper
   ========================================================================== */
.theme-card-check-wrapper {
  display: flex;
  height: 1.5rem;
  width: 1.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: #007BFF;
  color: #ffffff;
}

.dark .theme-card-check-wrapper {
  background-color: #3b82f6;
}

.theme-card-check-wrapper svg {
  height: 0.875rem;
  width: 0.875rem;
  stroke: currentColor;
}

/* ==========================================================================
   Theme Card Descriptions
   ========================================================================== */
.theme-card-content {
  margin-top: 1.25rem;
}

.theme-card-title {
  font-size: 1.125rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.dark .theme-card-title {
  color: #f8fafc;
}

.theme-card-description {
  margin-top: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5rem;
  color: #64748b;
  margin-bottom: 0;
}

.dark .theme-card-description {
  color: #94a3b8;
}

/* ==========================================================================
   Dashboard Preview Panels
   ========================================================================== */
.theme-card-preview-container {
  margin-top: 1.25rem;
  overflow: hidden;
  border-radius: 20px;
  padding: 1rem;
  transition: background 0.3s ease, border-color 0.3s ease;
}

.theme-preview-dots-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.theme-preview-dot {
  height: 0.625rem;
  width: 0.625rem;
  border-radius: 9999px;
}

.theme-preview-line-short {
  height: 0.625rem;
  width: 5rem;
  border-radius: 9999px;
}

.theme-preview-grid {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 0.75rem;
}

.theme-preview-grid-left,
.theme-preview-grid-right {
  border-radius: 1rem;
  padding: 0.75rem;
  box-sizing: border-box;
}

.theme-preview-line-medium {
  height: 0.625rem;
  width: 4rem;
  border-radius: 9999px;
}

.theme-preview-box-large {
  margin-top: 0.75rem;
  height: 3.5rem;
  border-radius: 0.75rem;
}

.theme-preview-line-tiny {
  height: 0.625rem;
  width: 2.5rem;
  border-radius: 9999px;
}

.theme-preview-box-small {
  margin-top: 0.75rem;
  height: 1.5rem;
  border-radius: 0.5rem;
}

.theme-preview-box-small + .theme-preview-box-small {
  margin-top: 0.5rem;
}

/* --------------------------------------------------------------------------
   Light Preview Explicit Colors
   -------------------------------------------------------------------------- */
.theme-card-preview-container.light-preview {
  border: 1px solid #e2e8f0;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.theme-card-preview-container.light-preview .theme-preview-dot,
.theme-card-preview-container.light-preview .theme-preview-line-short,
.theme-card-preview-container.light-preview .theme-preview-line-medium,
.theme-card-preview-container.light-preview .theme-preview-box-large,
.theme-card-preview-container.light-preview .theme-preview-line-tiny,
.theme-card-preview-container.light-preview .theme-preview-box-small {
  background-color: #e2e8f0;
}

.theme-card-preview-container.light-preview .theme-preview-grid-left,
.theme-card-preview-container.light-preview .theme-preview-grid-right {
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
}

/* --------------------------------------------------------------------------
   Dark Preview Explicit Colors
   -------------------------------------------------------------------------- */
.theme-card-preview-container.dark-preview {
  border: 1px solid #334155;
  background: linear-gradient(180deg, #0f172a 0%, #111827 100%);
}

.theme-card-preview-container.dark-preview .theme-preview-dot,
.theme-card-preview-container.dark-preview .theme-preview-line-short,
.theme-card-preview-container.dark-preview .theme-preview-line-medium,
.theme-card-preview-container.dark-preview .theme-preview-box-large,
.theme-card-preview-container.dark-preview .theme-preview-line-tiny,
.theme-card-preview-container.dark-preview .theme-preview-box-small {
  background-color: #475569;
}

.theme-card-preview-container.dark-preview .theme-preview-grid-left,
.theme-card-preview-container.dark-preview .theme-preview-grid-right {
  border: 1px solid #334155;
  background-color: #1e293b;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/ChangeTheme/index.css"],"names":[],"mappings":"AAAA;;+EAE+E;AAC/E;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,uDAAuD;EACvD,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,iDAAiD;EACjD,0CAA0C;EAC1C,2BAA2B;EAC3B,mCAAmC;EACnC,8DAA8D;AAChE;;AAEA;EACE,8CAA8C;EAC9C,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;AACb;;AAEA;;+EAE+E;AAC/E;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,eAAe;EACf,8CAA8C;EAC9C,oFAAoF;EACpF,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;;+EAE+E;AAC/E;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iDAAiD;EACjD,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;EAC9C,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;+EAE+E;AAC/E;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;+EAE+E;AAC/E;EACE,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;+EAE+E;AAC/E;EACE,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B","sourcesContent":["/* ==========================================================================\n   Outer Layout Container\n   ========================================================================== */\n.theme-outer-par {\n  width: 100%;\n  margin-top: 54px;\n  background-color: #f8fafc;\n  color: #0f172a;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  min-height: calc(100vh - 70px);\n  padding-bottom: 6rem;\n  box-sizing: border-box;\n  font-family: 'Inter', 'Outfit', sans-serif;\n}\n\n.dark .theme-outer-par {\n  background-color: #0f172a;\n  color: #f8fafc;\n}\n\n/* ==========================================================================\n   Sticky Header\n   ========================================================================== */\n.theme-sticky-header {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.7);\n  background-color: rgba(248, 250, 252, 0.9);\n  backdrop-filter: blur(24px);\n  -webkit-backdrop-filter: blur(24px);\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n}\n\n.dark .theme-sticky-header {\n  border-bottom: 1px solid rgba(51, 65, 85, 0.7);\n  background-color: rgba(15, 23, 42, 0.9);\n}\n\n.theme-header-content {\n  margin-left: auto;\n  margin-right: auto;\n  display: flex;\n  height: 4rem;\n  max-width: 48rem;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  box-sizing: border-box;\n}\n\n.theme-header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* ==========================================================================\n   Back Button & Title\n   ========================================================================== */\n.theme-back-button {\n  display: flex;\n  height: 2.5rem;\n  width: 2.5rem;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  border: none;\n  background-color: #f1f5f9;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.dark .theme-back-button {\n  background-color: #1e293b;\n}\n\n.theme-back-button:hover {\n  background-color: #e2e8f0;\n}\n\n.dark .theme-back-button:hover {\n  background-color: #334155;\n}\n\n.theme-back-button svg {\n  height: 1.25rem;\n  width: 1.25rem;\n  color: #64748b;\n  transition: color 0.3s ease;\n  stroke: currentColor;\n}\n\n.dark .theme-back-button svg {\n  color: #94a3b8;\n}\n\n.theme-header-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.dark .theme-header-title {\n  color: #f8fafc;\n}\n\n/* ==========================================================================\n   Main Content Layout\n   ========================================================================== */\n.theme-main-content {\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 48rem;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n/* ==========================================================================\n   Settings Card Container\n   ========================================================================== */\n.theme-settings-card {\n  border-radius: 28px;\n  border: 1px solid rgba(226, 232, 240, 0.7);\n  background-color: #ffffff;\n  padding: 1.5rem;\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);\n  transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;\n  box-sizing: border-box;\n}\n\n.dark .theme-settings-card {\n  border: 1px solid rgba(51, 65, 85, 0.7);\n  background-color: #0f172a;\n  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.4);\n}\n\n/* ==========================================================================\n   Appearance Header Info\n   ========================================================================== */\n.theme-appearance-section {\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.theme-card-heading {\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.dark .theme-card-heading {\n  color: #f8fafc;\n}\n\n.theme-card-subheading {\n  margin-top: 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5rem;\n  color: #64748b;\n  margin-bottom: 0;\n}\n\n.dark .theme-card-subheading {\n  color: #94a3b8;\n}\n\n/* ==========================================================================\n   Active Theme Badge\n   ========================================================================== */\n.theme-active-badge {\n  border-radius: 9999px;\n  background-color: #E6F2FF;\n  padding: 0.5rem 1rem;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  color: #007BFF;\n  line-height: 1.2;\n}\n\n.theme-active-badge .active-badge-label {\n  font-size: 0.7rem;\n  font-weight: 500;\n}\n\n.theme-active-badge .active-badge-value {\n  font-size: 0.85rem;\n  font-weight: 700;\n}\n\n.dark .theme-active-badge {\n  background-color: rgba(59, 130, 246, 0.15);\n  color: #3b82f6;\n}\n\n/* ==========================================================================\n   Cards Grid\n   ========================================================================== */\n.theme-cards-grid {\n  margin-top: 1.5rem;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n}\n\n@media (min-width: 768px) {\n  .theme-cards-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n/* ==========================================================================\n   Theme Selection Card Buttons\n   ========================================================================== */\n.theme-card {\n  border-radius: 24px;\n  border: 1px solid rgba(226, 232, 240, 0.7);\n  padding: 1.25rem;\n  text-align: left;\n  transition: all 0.2s ease;\n  background-color: #ffffff;\n  cursor: pointer;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.dark .theme-card {\n  border: 1px solid rgba(51, 65, 85, 0.7);\n  background-color: #0f172a;\n}\n\n.theme-card:hover {\n  border-color: rgba(37, 99, 235, 0.4);\n  background-color: #f8fafc;\n}\n\n.dark .theme-card:hover {\n  border-color: rgba(59, 130, 246, 0.4);\n  background-color: rgba(30, 41, 59, 0.4);\n}\n\n.theme-card-disabled {\n  cursor: not-allowed !important;\n}\n\n.theme-card-disabled .theme-card-title {\n  color: #64748b;\n}\n\n.theme-card-disabled .theme-card-description {\n  color: #94a3b8;\n}\n\n.theme-card-disabled:hover {\n  border-color: rgba(226, 232, 240, 0.7) !important;\n  background-color: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.dark .theme-card-disabled:hover {\n  border-color: rgba(51, 65, 85, 0.7) !important;\n  background-color: #0f172a !important;\n  box-shadow: none !important;\n}\n\n.theme-card-active {\n  border-color: #3b82f6 !important;\n  background-color: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.dark .theme-card-active {\n  border-color: #3b82f6 !important;\n  background-color: #0f172a !important;\n  box-shadow: none !important;\n}\n\n.theme-card-header {\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n/* ==========================================================================\n   Theme Card Icons\n   ========================================================================== */\n.theme-card-icon-wrapper.light-icon {\n  display: flex;\n  height: 3rem;\n  width: 3rem;\n  align-items: center;\n  justify-content: center;\n  border-radius: 1rem;\n  background-color: #fef3c7;\n  color: #d97706;\n  border: 1px solid #fde68a;\n}\n\n.theme-card-icon-wrapper.light-icon svg {\n  height: 1.25rem;\n  width: 1.25rem;\n}\n\n.theme-card-icon-wrapper.dark-icon {\n  display: flex;\n  height: 3rem;\n  width: 3rem;\n  align-items: center;\n  justify-content: center;\n  border-radius: 1rem;\n  background-color: #0f172a;\n  color: #ffffff;\n  border: 1px solid #1e293b;\n}\n\n.theme-card-icon-wrapper.dark-icon svg {\n  height: 1.25rem;\n  width: 1.25rem;\n}\n\n/* ==========================================================================\n   Checkmark Wrapper\n   ========================================================================== */\n.theme-card-check-wrapper {\n  display: flex;\n  height: 1.5rem;\n  width: 1.5rem;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  background-color: #007BFF;\n  color: #ffffff;\n}\n\n.dark .theme-card-check-wrapper {\n  background-color: #3b82f6;\n}\n\n.theme-card-check-wrapper svg {\n  height: 0.875rem;\n  width: 0.875rem;\n  stroke: currentColor;\n}\n\n/* ==========================================================================\n   Theme Card Descriptions\n   ========================================================================== */\n.theme-card-content {\n  margin-top: 1.25rem;\n}\n\n.theme-card-title {\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.dark .theme-card-title {\n  color: #f8fafc;\n}\n\n.theme-card-description {\n  margin-top: 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5rem;\n  color: #64748b;\n  margin-bottom: 0;\n}\n\n.dark .theme-card-description {\n  color: #94a3b8;\n}\n\n/* ==========================================================================\n   Dashboard Preview Panels\n   ========================================================================== */\n.theme-card-preview-container {\n  margin-top: 1.25rem;\n  overflow: hidden;\n  border-radius: 20px;\n  padding: 1rem;\n  transition: background 0.3s ease, border-color 0.3s ease;\n}\n\n.theme-preview-dots-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.theme-preview-dot {\n  height: 0.625rem;\n  width: 0.625rem;\n  border-radius: 9999px;\n}\n\n.theme-preview-line-short {\n  height: 0.625rem;\n  width: 5rem;\n  border-radius: 9999px;\n}\n\n.theme-preview-grid {\n  margin-top: 1rem;\n  display: grid;\n  grid-template-columns: 1.2fr 0.8fr;\n  gap: 0.75rem;\n}\n\n.theme-preview-grid-left,\n.theme-preview-grid-right {\n  border-radius: 1rem;\n  padding: 0.75rem;\n  box-sizing: border-box;\n}\n\n.theme-preview-line-medium {\n  height: 0.625rem;\n  width: 4rem;\n  border-radius: 9999px;\n}\n\n.theme-preview-box-large {\n  margin-top: 0.75rem;\n  height: 3.5rem;\n  border-radius: 0.75rem;\n}\n\n.theme-preview-line-tiny {\n  height: 0.625rem;\n  width: 2.5rem;\n  border-radius: 9999px;\n}\n\n.theme-preview-box-small {\n  margin-top: 0.75rem;\n  height: 1.5rem;\n  border-radius: 0.5rem;\n}\n\n.theme-preview-box-small + .theme-preview-box-small {\n  margin-top: 0.5rem;\n}\n\n/* --------------------------------------------------------------------------\n   Light Preview Explicit Colors\n   -------------------------------------------------------------------------- */\n.theme-card-preview-container.light-preview {\n  border: 1px solid #e2e8f0;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n}\n\n.theme-card-preview-container.light-preview .theme-preview-dot,\n.theme-card-preview-container.light-preview .theme-preview-line-short,\n.theme-card-preview-container.light-preview .theme-preview-line-medium,\n.theme-card-preview-container.light-preview .theme-preview-box-large,\n.theme-card-preview-container.light-preview .theme-preview-line-tiny,\n.theme-card-preview-container.light-preview .theme-preview-box-small {\n  background-color: #e2e8f0;\n}\n\n.theme-card-preview-container.light-preview .theme-preview-grid-left,\n.theme-card-preview-container.light-preview .theme-preview-grid-right {\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n}\n\n/* --------------------------------------------------------------------------\n   Dark Preview Explicit Colors\n   -------------------------------------------------------------------------- */\n.theme-card-preview-container.dark-preview {\n  border: 1px solid #334155;\n  background: linear-gradient(180deg, #0f172a 0%, #111827 100%);\n}\n\n.theme-card-preview-container.dark-preview .theme-preview-dot,\n.theme-card-preview-container.dark-preview .theme-preview-line-short,\n.theme-card-preview-container.dark-preview .theme-preview-line-medium,\n.theme-card-preview-container.dark-preview .theme-preview-box-large,\n.theme-card-preview-container.dark-preview .theme-preview-line-tiny,\n.theme-card-preview-container.dark-preview .theme-preview-box-small {\n  background-color: #475569;\n}\n\n.theme-card-preview-container.dark-preview .theme-preview-grid-left,\n.theme-card-preview-container.dark-preview .theme-preview-grid-right {\n  border: 1px solid #334155;\n  background-color: #1e293b;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
